import React from "react";
import { Inbox } from "lucide-react";

// El mismo bloque —icono al 30 % de opacidad, título y frase— estaba repetido
// en Palabra del Día, el archivo de evangelios, Formación, Eventos, Recursos y
// Podcast, cada uno con su propio icono y su propio margen.
export default function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  className = "",
  ...rest
}) {
  return (
    <div className={`text-center py-20 px-6 ${className}`} {...rest}>
      <Icon className="w-10 h-10 mx-auto mb-5 opacity-30" aria-hidden="true" strokeWidth={1.5} />
      {title && <p className="font-heading font-semibold text-lg mb-2">{title}</p>}
      {description && (
        <p className="text-muted-foreground max-w-md mx-auto leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-8 flex justify-center">{action}</div>}
    </div>
  );
}
